import templateOnly from '@ember/component/template-only';

export interface ChipSignature {
  Args: {
    hasError?: boolean;
    iconName?: string;
    subTitle?: string;
    title: string;
  };
}

const ChipComponent = templateOnly<ChipSignature>();

export default ChipComponent;
